import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import VideoPreviewCardBox from './VideoPreviewCardBox'
import useStyles from './styles/VideoCardItemStyle'


class VideoCardItem extends Component {
  render() {
    const classes = this.props.classes
    return (
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="center"
      >
        <Grid item className={classes.smallCarouselItem}>
          <VideoPreviewCardBox
            currentSlide={this.props.currentSlide}
            main={this.props.main}
            videoDetails={this.props.videoDetails}
            index={this.props.index}
          />
        </Grid>
      </Grid>
    )
  }
}
export default withStyles(useStyles)(VideoCardItem)
